/**
 * Entry for Heavy Rig Rush — mounts the arcade endless racer, hydrates HUD DOM,
 * keyboard lane changes (arrows / A–D), on-screen lane buttons, and swaps OBJ rigs when loads finish.
 */

import { createEndlessRaceController } from "./game/endlessRacer/endlessRacerGame.js";
import { loadTruckModelTemplate } from "./loadTruckModel.js";

const els = {
  mount: document.querySelector("#game"),
  score: document.querySelector("#score"),
  speed: document.querySelector("#speed"),
  lives: document.querySelector("#lives"),
  toast: document.querySelector("#toast"),
  gameOver: document.querySelector("#gameOver"),
  finalScore: document.querySelector("#finalScore"),
  restart: document.querySelector("#restart"),
  left: document.querySelector("#leftButton"),
  right: document.querySelector("#rightButton")
};

let racer;
let toastTimer = 0;

/**
 * Lightweight toast shim — fades without stealing focus during lane changes.
 *
 * @param {string} text
 */
function showToast(text) {
  if (!els.toast) return;
  els.toast.textContent = text;
  els.toast.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => els.toast.classList.remove("is-visible"), 900);
}

racer = createEndlessRaceController({
  mount: els.mount,
  hud: {
    onScoreUi: (value) => {
      if (els.score) els.score.textContent = String(value);
    },
    onSpeedUi: (value) => {
      if (els.speed) els.speed.textContent = String(value);
    },
    onLivesUi: (value) => {
      if (els.lives) els.lives.textContent = String(value);
    },
    onToast: showToast,
    onRunningChange: (running) => {
      if (running && els.gameOver) {
        els.gameOver.hidden = true;
      } else if (!running && els.finalScore && els.gameOver) {
        els.finalScore.textContent = `Score: ${Math.floor(racer.state.score)}`;
        els.gameOver.hidden = false;
      }
    }
  }
});

loadTruckModelTemplate(showToast)
  .then((tpl) => {
    if (tpl) racer.setPlayerFromTemplate(tpl);
    else showToast("Reference OBJ missing — using placeholder rig");
  })
  .catch(() => showToast("Truck OBJ offline — placeholders active"));

window.addEventListener("resize", () => racer.resize());

window.addEventListener("keydown", (event) => {
  const ae = document.activeElement;
  if (ae instanceof HTMLInputElement || ae instanceof HTMLTextAreaElement) return;
  if (ae && ae instanceof HTMLElement && ae.isContentEditable) return;
  if (event.code === "ArrowLeft" || event.code === "KeyA") racer.moveLane(-1);
  if (event.code === "ArrowRight" || event.code === "KeyD") racer.moveLane(1);
  if (event.code === "KeyR") resetFromUi();
});

els.left?.addEventListener("click", () => racer.moveLane(-1));
els.right?.addEventListener("click", () => racer.moveLane(1));

/**
 * Mirrors both restart button semantics and prototype’s <kbd>R</kbd> rebound.
 */
function resetFromUi() {
  racer.resetRun();
}

els.restart?.addEventListener("click", resetFromUi);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
    /* Quiet on file:// or restrictive hosts */
  });
}
